import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ClassificacaoModalComponent } from '../modals/classificacao-modal/classificacao-modal.component';

// jquery
declare const $: any;
@Component({
  selector: 'app-testes',
  templateUrl: './testes.component.html',
  styleUrls: ['./testes.component.scss']
})
export class TestesComponent implements OnInit {
  items: any[] = [{ id: 0, name: 'Noah' }, { id: 1, name: 'Angelo' }, { id: 2, name: 'Mailson Queiroz' },];
  public htmlCode: string;
  public htmlDoc: HTMLElement;

  public mentionConfig = {
    items: this.items,
    labelKey: 'name',
    mentionSelect: (e: any) => {
      return '##' + e.name + '##';
    },
  };
  texto: string;
  selecionados: number[] = [];
  constructor(public dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  onMentionSelect(selection): string { return '<b>' + selection.label + '</b>'; }

  itemSelected(event: any) {
    this.selecionados.push(event.id);
    setTimeout(() => {
      this.htmlDoc = document.getElementById('my-content');
      this.htmlDoc.innerHTML = this.htmlDoc.innerHTML.replace(
        '##' + event.name + '##',
        ' <b data-id=' + event.id + ' class="mention-user">@' + event.name + '</b>&nbsp;'
      );
      // put the cursor to the end of field again...
      this.selectEnd();
    }, 10);
  }

  selectEnd() {
    let range, selection;
    range = document.createRange();
    range.selectNodeContents(this.htmlDoc);
    range.collapse(false);
    selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  gerar() {
    this.selecionados.forEach(element => {
      if (!this.htmlDoc.innerHTML.includes('data-id="' + element + '"')) {
        this.selecionados = this.selecionados.filter(function (item) {
          return item !== element;
        });
      }
    });
    // var doc = new DOMParser().parseFromString(this.htmlDoc.innerHTML, "text/xml");
    // $("input[data-id]").each(function () {
    //   var testdata = $(this).data('id');
    //   $(this).val(testdata);
    //   alert(testdata);
    // });
  }

  classificacoes() {

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ClassificacaoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {

    });
  }
}
